import { isString } from "@/lib/utils/typeof";

/**
 * Accents and case are dropped, so "jose" finds "José".
 */
export const toSearchText = (text: string) =>
  text
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();

/**
 * The items where any of `getSearchableTexts` contains `query`, ignoring
 * accents and case. An empty query keeps them all, as the same array.
 */
export const filterBySearchText = <Item>(
  items: Item[],
  query: string,
  getSearchableTexts: (item: Item) => (string | undefined)[]
): Item[] => {
  const needle = toSearchText(query.trim());

  if (needle === "") {
    return items;
  }

  return items.filter((item) =>
    getSearchableTexts(item)
      .filter(isString)
      .some((text) => toSearchText(text).includes(needle))
  );
};
